// @flow

const featureTesting = {
  getTestResult(modernizrFeatureName: string): mixed {
    if (typeof window !== 'undefined' && typeof window.Modernizr !== 'undefined') {
      return window.Modernizr[modernizrFeatureName];
    }
  },
};

export default featureTesting;
